import { HttpService, Query, QueryHandler, TaggedUrl, Tags, transformDTODate } from '@skylab-shared/core';
import { KsefDocumentStatus, KsefSendSubmissionMode, SaleSendToKsefValidationError, SaleSendToKsefValidationWarning } from '@skylab-shared/dataModel';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { Transform } from 'class-transformer';

export interface SaleDocumentsToDispatchKsefGridItem {
    documentId: number;
    documentNumber: string;
    issueDate: Date;
    validations: SaleDocumentKsefValidation;
    version: string;
    ksefHash: string;
    ksefDocumentStatus: KsefDocumentStatus;
    ksefXmlImported: boolean;
    ksefCertificateUrl: string;
}

export interface SaleDocumentKsefValidation {
    errors: SaleDocumentKsefValidationMessage[];
    warnings: SaleDocumentKsefValidationMessage[];
}

export interface SaleDocumentKsefValidationMessage {
    kind: SaleSendToKsefValidationWarning | SaleSendToKsefValidationError;
    placeholders: string[];
}

class SaleDocumentsToDispatchKsefItemDTO {
    public id!: number;
    public documentNumber!: string;
    @Transform(transformDTODate, { toClassOnly: true }) public readonly issueDate!: Date;
    public ksefDocumentStatus!: KsefDocumentStatus;
    public validations!: SaleDocumentKsefValidation;
    public ksefXmlImported: boolean;
    public ksefHash!: string;
    public version!: string;
    public ksefCertificateUrl!: string;
}

export interface SaleGetDocumentsToDispatchKsefGridQueryParams {
    documents: {
        documentId: number;
        ksefSubmissionMode: KsefSendSubmissionMode;
        version: string;
    }[]
}

export class SaleGetDocumentsToDispatchKsefGridQuery extends Query<SaleDocumentsToDispatchKsefGridItem[]> {
    public constructor(public readonly params: SaleGetDocumentsToDispatchKsefGridQueryParams) {
        super();
    }
}

export class SaleGetDocumentsToDispatchKsefGridQueryHandlerBase implements QueryHandler<SaleGetDocumentsToDispatchKsefGridQuery, SaleDocumentsToDispatchKsefGridItem[]> {
    public constructor(
        private readonly $http: HttpService
    ) { }

    public async handleAsync(query: SaleGetDocumentsToDispatchKsefGridQuery): Promise<SaleDocumentsToDispatchKsefGridItem[]> {
        const url = TaggedUrl.join('eInvoices/documentsToDispatchKsef', [Tags.Api]);
        const { data } = await this.$http.post<SaleDocumentsToDispatchKsefItemDTO[]>(url, query.params.documents, {
            dto: SaleDocumentsToDispatchKsefItemDTO,
            timeout: MS_PER_MINUTE
        });
        return data.map(elem => ({...elem, documentId: elem.id}));
    }
}
